const transformDataForMoodChart = data => {
  if (!data || data.constructor !== Array) {
    return {}
  }

  const reducedData = data.reduce((object, item) => {
    const ratio = item.ratio
    let key = null
    if (ratio < 0.95) {
      key = 'poor'
    } else if (ratio < 1.05) {
      key = 'moderate'
    } else {
      key = 'good'
    }
    object[key] = (object[key] || []).concat(item)
    return object
  }, {})

  return reducedData
}

export default transformDataForMoodChart



// WEBPACK FOOTER //
// ./src/utility/transformDataForMoodChart.js